import { Nullable } from '@/utils/types';

export enum BrokerPercentageType {
  offTop = 'Off Top',
  ofRemaining = 'Of Remaining'
}

export interface IDealBrokerFormData {
  percentage: Nullable<number>;
  percentage_type: BrokerPercentageType,
  referring_agent: boolean;
  receiving_agent: boolean;
  include_in_invoice: boolean;
}
